// removes the trailing slash from a URL, e.g. https://domain.com/ -> https://domain.com
const stripTrailingSlash = (url = '') => url.replace(/\/$/, '');

export default stripTrailingSlash;
